import { render, staticRenderFns } from "./MatchPairSlideOptions.vue?vue&type=template&id=39287cf7&scoped=true"
import script from "./MatchPairSlideOptions.vue?vue&type=script&lang=js"
export * from "./MatchPairSlideOptions.vue?vue&type=script&lang=js"
import style0 from "./MatchPairSlideOptions.vue?vue&type=style&index=0&id=39287cf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39287cf7",
  null
  
)

export default component.exports